import Enumeration from 'Lib/utilities/Enumeration';

const ListReportTypes = new Enumeration([
    { id: 1, key: 'Lease', name: 'Lease' },
    { id: 2, key: 'Portfolio', name: 'Portfolio' },
    { id: 3, key: 'Property', name: 'Property' },
    { id: 4, key: 'Unit', name: 'Unit' },
    { id: 5, key: 'WorkOrder', name: 'Work Order' },
    { id: 6, key: 'Screening', name: 'Screening' },
    { id: 7, key: 'Owner', name: 'Owner' },
    { id: 8, key: 'Tenant', name: 'Tenant' },
    { id: 9, key: 'Vendor', name: 'Vendor' },
    { id: 10, key: 'Association', name: 'Association' },
    { id: 11, key: 'WorkOrderProject', name: 'Work Order Project' }
]);

export default ListReportTypes;
